export default{

    getGameData: (state) => (attr) => {
        let atributo = state[attr]
        let atributoReturn = ''
        if(atributo){
            atributoReturn = atributo
        }else{
            let atributoLocal = localStorage.getItem(attr)
            atributoReturn = atributoLocal
        }

        return atributoReturn
    },
    getLastExtract: (state) => {
        let tamanho = state.extract.length
        if(tamanho == 0){
            return {}
        }
        return state.extract[tamanho - 1]
    },
    getScore: (state) => {
        return state.currentScore
    },
    getTimeDiscount: (state) => {
        // console.log('getted time discount: ', state.timeDiscount)
        return state.timeDiscount
    }
}